export const messages = {
  en: {
    editPurchaseApply: {
      title: 'Edit Purchase Apply',
      back: 'Back',
      contactPerson: 'Contact Person',
      contactPersonPlaceholder: 'Required, please enter contact person',
      contactPhone: 'Contact Phone',
      contactPhonePlaceholder: 'Required, please enter contact phone',
      applyDescription: 'Apply Description',
      applyDescriptionPlaceholder: 'Required, please enter apply description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      itemType: 'Item Type',
      itemName: 'Item Name(Code)',
      itemSpec: 'Item Specification',
      price: 'Price',
      selectPrice: 'Select Price',
      itemStock: 'Item Stock',
      applyQuantity: 'Apply Quantity',
      applyQuantityPlaceholder: 'Required, please enter apply quantity',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      operation: 'Operation',
      remove: 'Remove',
      submit: 'Submit',
      noItemsSelected: 'No items selected',
      updateSuccess: 'Update success',
      updateFailed: 'Update failed'
    }  
  },
  zh: {
    editPurchaseApply: {
      title: '编辑采购申请',
      back: '返回',
      contactPerson: '联系人',
      contactPersonPlaceholder: '必填，请填写联系人',
      contactPhone: '联系电话',
      contactPhonePlaceholder: '必填，请填写联系电话',
      applyDescription: '申请说明',
      applyDescriptionPlaceholder: '必填，请填写申请说明',
      purchaseItems: '采购物品',
      select: '选择',
      itemType: '物品类型',
      itemName: '物品名称(编码)',
      itemSpec: '物品规格',
      price: '价格',
      selectPrice: '请选择价格',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      applyQuantityPlaceholder: '必填，请填写申请数量',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      noItemsSelected: '未选择采购物品',
updateSuccess: '修改成功',
      updateFailed: '修改失败'
    }
  },
  'zh-TW': {
    editPurchaseApply: {
      title: '編輯採購申請',
      back: '返回',
      contactPerson: '聯繫人',
      contactPersonPlaceholder: '必填，請填寫聯繫人',
      contactPhone: '聯繫電話',
      contactPhonePlaceholder: '必填，請填寫聯繫電話',
      applyDescription: '申請說明',
      applyDescriptionPlaceholder: '必填，請填寫申請說明',
      purchaseItems: '採購物品',
      select: '選擇',
      itemType: '物品類型',
      itemName: '物品名稱(編碼)',
      itemSpec: '物品規格',
      price: '價格',
      selectPrice: '請選擇價格',
      itemStock: '物品庫存',
      applyQuantity: '申請數量',
      applyQuantityPlaceholder: '必填，請填寫申請數量',
      remark: '備註',
      remarkPlaceholder: '選填，請填寫備註',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      noItemsSelected: '未選擇採購物品',
      updateSuccess: '修改成功',
      updateFailed: '修改失敗'
    }
  }
}